import { featuredCollections } from '@/mocks/home';

export default function FeaturedCollections() {
  const [lead, ...rest] = featuredCollections;

  return (
    <section id="collections" className="w-full border-t border-background-200 bg-background-100 px-4 md:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300 pb-5">
        <div>
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">03 / 热门合集</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">最近整理的四期</h3>
        </div>
        <a
          href="#archive"
          className="inline-flex items-center gap-2 text-sm font-label text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          全部合集归档
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </span>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        <article className="lg:col-span-6 group">
          <div className="w-full h-[240px] md:h-[320px] overflow-hidden rounded-lg bg-background-200">
            <img
              src={lead.image}
              alt={`${lead.title} 合集封面`}
              title={`${lead.title} 17.cn黑料合集`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
            />
          </div>
          <div className="mt-4 flex items-center gap-3">
            <span className="text-xs font-label tracking-[0.25em] text-accent-700">{lead.code}</span>
            <span className="h-px flex-1 bg-background-300" />
          </div>
          <h4 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">
            <a href="#archive" className="transition-colors hover:text-primary-600 cursor-pointer">
              {lead.title}
            </a>
          </h4>
          <p className="mt-2 text-sm leading-7 text-foreground-600">{lead.summary}</p>
          <div className="mt-4 flex flex-wrap items-center gap-2">
            {lead.tags.map((tag) => (
              <span key={tag} className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-label text-secondary-900">
                {tag}
              </span>
            ))}
            <span className="text-xs font-label text-foreground-500">{lead.meta}</span>
          </div>
        </article>

        <div className="lg:col-span-6 divide-y divide-background-200 border-t border-background-200 lg:border-t-0">
          {rest.map((item) => (
            <article key={item.id} className="group flex items-start gap-4 py-5 first:pt-0 lg:first:pt-0">
              <span className="mt-1 font-heading text-sm md:text-base font-bold text-primary-500 shrink-0 w-16">
                {item.code.replace('第 ', '').replace(' 期', '期')}
              </span>
              <div className="min-w-0">
                <h4 className="font-heading text-lg font-bold text-foreground-950">
                  <a href="#archive" className="transition-colors hover:text-primary-600 cursor-pointer">
                    {item.title}
                  </a>
                </h4>
                <p className="mt-1.5 text-sm leading-6 text-foreground-600">{item.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  {item.tags.map((tag) => (
                    <span key={tag} className="rounded-full bg-background-200/80 px-2.5 py-0.5 text-[11px] font-label text-foreground-700">
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs font-label text-foreground-500">{item.meta}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}